import React, {Component} from 'react';
import {setLoading} from "@/store/slices/chatbotDetails";

class Geolocation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error:false,
            location:null,
        }
    }
     componentDidMount() {
        if(!navigator.geolocation) {
            this.setState({error:true})
            this.props.addAnswer({})
        }
        else {
            setLoading(true)
            navigator.geolocation.getCurrentPosition( position =>{
                const latitude  = position.coords.latitude;
                const longitude = position.coords.longitude;
                setLoading(false)
                this.setState({location:{lat:latitude,lng:longitude},error:false})
                this.props.addAnswer({lat:latitude,lng:longitude})
            }, error =>{
                this.setState({error:true})
                setLoading(false)
                this.props.addAnswer({})
            },{
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            });
        }
    }

    render() {
       return (
           <div>
               {this.state.error!==null &&
                   <p>Unable to fetch the location.Please check your browser permissions</p>
               }
               {this.state.location!==null &&
                   <p>lat:{this.state.location.lat},lng:{this.state.location.lng}</p>
               }
           </div>
       )
    }
}

export default Geolocation;